import React, { useContext } from "react";
import { CurrentContext, SetterContext } from "../../App";

function AmountSelector( props: {
	name: string,
	min: number,
	max: number
} ) {
	const current = useContext( CurrentContext );
	const createSetter = useContext( SetterContext );
	const key = `amount-${props.name}`;
	const set = createSetter( key );

	const currentAmount = current[key];

	if ( currentAmount === undefined ) {
		set( props.min );
	}

	const numberArray = [ ...Array( props.max - props.min + 1 ) ].map( ( _, i ) => i + props.min );

	return <div className="flex button-area" id="fahrzeug-laenge-buttons">
		{numberArray.map(
			( i ) =>
				<label
					title={i.toString()}
					className={"config-button config-button-amount" + ( currentAmount === i ? " selected" : "" )}
					htmlFor={`${key}-${i}`}
				>
					<input
						type={"radio"}
						value={i}
						id={`${key}-${i}`}
						name={key}
						style={{
							display: "none",
						}}
						checked={currentAmount === i ? true : undefined}
						onClick={() => set( i )}
					/>
					{i}
				</label>,
		)}
	</div>;
}

export default AmountSelector;
